<script setup lang="ts">
import { useDialog, useLoadingBar, useMessage, useNotification } from "naive-ui";

declare global {
  interface Window {
    $message: ReturnType<typeof useMessage>;
    $loadingBar: ReturnType<typeof useLoadingBar>;
    $notification: ReturnType<typeof useNotification>;
    $dialog: ReturnType<typeof useDialog>;
  }
}

window.$message = useMessage();
window.$loadingBar = useLoadingBar();
window.$notification = useNotification();
window.$dialog = useDialog();
</script>

<template>
  <slot></slot>
</template>
